module.exports = __webpack_public_path__ + "static/media/ophos-intro.4db7660a.svg";